import { AfterViewInit, Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, Output, Renderer2, ViewChild } from '@angular/core';
import { UiHelper } from '../helpers/ui.helper';

@Directive({
  selector: '[recyleView]',
})
export class RecyleView implements AfterViewInit {
  /*
  @Usage notes:

  Use main container, position: relative !!

  Two child item inside.
  `
    <div class="recyle-buttons">
    <div matRipple>
      <div class="svg">
        <span class="svg favoried"><fa-icon [icon]="faIcons.faStar"></fa-icon></span>
        <span class="svg Unfavoried"><fa-icon [icon]="faIcons.faStarIncide"></fa-icon></span>
      </div>
    </div>
  </div>
  `
  `
  And slide one full width.
  `

  <p recyleView >

   */
  elemID = '';

  favoried;
  Unfavoried;
  svgItem;
  passPoint = false;

  @Input() initialOrigin = '-50';
  @Input() favorableState = false;
  @Output() favorableStateChanged: EventEmitter<any> = new EventEmitter();

  @ViewChild('recyleButton', { static: true }) recyleButton: ElementRef;

  @HostBinding('style.left') elemLeft: string;
  @HostBinding('style.display') elemDisp: string;
  @HostBinding('style.transition') elemTra: string;
  @HostBinding('style.width') elemWidth: string;

  @HostListener('panmove', ['$event'])
  onPanMove(event) {
    // ////console.log(event.distance);
    const _Show = false;
    if (event.distance > 75 && event.distance < 175) {
      this.elemLeft = parseInt(event.distance) + parseInt(this.initialOrigin) + 'px';
      //////console.log(this.passPoint, this.favorableState);
      //////console.log(event.distance);
      if (event.distance > 125) {
        if (!this.passPoint) {
          this.favorableState ? this.setfavorableState(false) : this.setfavorableState(true);
          this.passPoint = true;
        }
      } else {
        this.passPoint = false;
      }
    } else if (event.distance >= 175) {
      this.elemLeft = '175px';
    }
  }

  @HostListener('panend', ['$event'])
  onPanEnd(event) {
    this.elemLeft = this.initialOrigin + 'px';
    this.passPoint = false;
    /*
        if (event.distance > 50) {
          this.setfavorableState(true);
        } else {
          this.setfavorableState(false);
        }

     */
  }

  constructor(private el: ElementRef, private renderer: Renderer2, private _UiHelper: UiHelper) {}

  setfavorableState(x) {
    if (!x) {
      this.Unfavoried.style.setProperty('display', 'block');
      this.favoried.style.setProperty('display', 'none');
      this.renderer.removeClass(this.el.nativeElement, 'favoriedState');
    } else {
      this.favoried.style.setProperty('display', 'block');
      this.Unfavoried.style.setProperty('display', 'none');
      this.renderer.addClass(this.el.nativeElement, 'favoriedState');
    }
    this.favorableState = x;
    this.favorableStateChanged.emit(this.favorableState);
  }

  ngAfterViewInit(): void {
    this.elemDisp = 'relative';
    this.elemTra = '0.2s all';
    this.elemLeft = this.initialOrigin + 'px';
    this.el.nativeElement.querySelector('.recyle-buttons');
    this.favoried = this.el.nativeElement.querySelector('.favoried');
    this.Unfavoried = this.el.nativeElement.querySelector('.Unfavoried');
    if (!this.favorableState) {
      this.Unfavoried.style.setProperty('display', 'block');
      this.favoried.style.setProperty('display', 'none');
      this.renderer.removeClass(this.el.nativeElement, 'favoriedState');
    } else {
      this.favoried.style.setProperty('display', 'block');
      this.Unfavoried.style.setProperty('display', 'none');
      this.renderer.addClass(this.el.nativeElement, 'favoriedState');
    }

    this._UiHelper.windowsWidth;
    this._UiHelper.windowResized.subscribe(x => {
      this.elemWidth = this._UiHelper.windowsWidth + Math.abs(parseInt(this.initialOrigin)) + 'px';
    });

    this.elemWidth = this._UiHelper.windowsWidth + Math.abs(parseInt(this.initialOrigin)) + 'px';
  }
}
